import { ExternalLink } from 'assets/icons';
import EmployeeAvatar from 'components/assign/EmployeeAvatar';
import Button from 'components/button';
import useText from 'hooks/useText';

// Who the task is about: the contact (or the company), their role and how to
// reach them, and the button that opens the company's panel.
const TaskContactCard = ({ task, onOpenCompany }) => {
  const { text } = useText('taskPanel');
  const name = task.contactName || task.company?.name;
  const [firstname, ...rest] = name.split(' ');
  const reach = task.type === 'email' ? task.company?.email : task.company?.phone;
  return (
    <div className="flex items-center gap-3 rounded-lg border border-gray-200 p-3">
      <EmployeeAvatar employee={{ firstname, lastname: rest.join(' ') }} size={40} />
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-gray-900">{name}</p>
        <p className="truncate text-xs text-gray-600">
          {[task.contactName && task.company?.contactRole, task.contactName && task.company?.name, reach]
            .filter(Boolean)
            .join(' · ')}
        </p>
      </div>
      {task.company && (
        <Button color="SECONDARY" size="SM" className="shrink-0" onClick={() => onOpenCompany(task.company)}>
          <ExternalLink wh={16} color="currentColor" />
          {text('fiche')}
        </Button>
      )}
    </div>
  );
};

export default TaskContactCard;
